<template>
    <div class="ui container">
        <div class="ui three item pointing menu" ref="tabs">
            <a class="item active" data-tab="processes">
                <i class="settings icon"></i>
                {{ $t('processes') }}
            </a>
            <a class="item" data-tab="storage">
                <i class="database icon"></i>
                {{ $t('external databases') }}
            </a>
            <a class="item" data-tab="data_sources">
                <i class="bar chart icon"></i>
                {{ $t('data sources') }}
            </a>
        </div>
        <div class="ui bottom attached tab active" data-tab="processes">
            <div class="ui container grid">
                <div class="five wide column" style="padding-left:0;">
                    <deployment-management
                        @select_process="set_selected_process"
                        ref="deployment_management"
                    />
                </div>
                <div class="eleven wide column" style="padding-right:0;">
                    <process-management
                        v-if="selected_process.uuid"
                        :process="selected_process"
                        @process_deleted="delete_process"
                        @process_default="process_default"
                    />
                </div>
            </div>
        </div>
        <div class="ui bottom attached tab" data-tab="storage">
            <database-management />
        </div>
        <div class="ui bottom attached tab" data-tab="data_sources">
            <datasource-management />
        </div>
    </div>
</template>

<script>
import DeploymentManagement from './process/deployment/DeploymentManagement'
import ProcessManagement from './process/ProcessManagement'
import DatabaseManagement from './database/DatabaseManagement'
import DatasourceManagement from './datasource/DatasourceManagement'

export default {
    name: 'NgineCore',
    components: {
        DeploymentManagement,
        ProcessManagement,
        DatabaseManagement,
        DatasourceManagement,
    },
    data() {
        return { selected_process: {} }
    },
    methods: {
        set_selected_process(process) {
            let vm = this
            vm.selected_process = {}
            setTimeout(function() {
                vm.selected_process = process
            }, 100)
        },
        delete_process(process_uuid) {
            this.selected_process = {}
            this.$refs.deployment_management.remove_process(process_uuid)
        },
        process_default(process_uuid) {
            this.$refs.deployment_management.process_default(process_uuid)
        },
    },
    mounted() {
        let vm = this
        window
            .jQuery(vm.$refs.tabs)
            .find('.item')
            .tab()
    },
    watch: {},
}
</script>
